import { FC } from 'react'
import { CustomBaseAlert } from './CustomBaseAlert'

export const CustomWarningAlert: FC<{ children?: React.ReactNode }> = ({
	children,
}) => {
	return <CustomBaseAlert type="warning">{children}</CustomBaseAlert>
}
